"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDictionaryValue = getDictionaryValue;
function getDictionaryValue(_ref) {
  var id = _ref.id,
    defs = _ref.defs,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue;
  var def = (defs || []).find(function (s) {
    return s.id === id;
  });
  return def && def.label || defaultValue;
}